import { render, staticRenderFns } from "./Static_PageForm.vue?vue&type=template&id=99675c22"
import script from "./Static_PageForm.vue?vue&type=script&lang=js"
export * from "./Static_PageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports